import React, {useState, useEffect} from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./TypeMaterials.css"
import axiosInstance from "../../../Config/axiosInstance";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Alert, Snackbar } from "@mui/material";

const EditTypeMaterials = () => {
    const navigate = useNavigate();
    const {id} = useParams();

    const[formData, setFormData] = useState({
        name: "",
        code: "",
    });
    
    //state-uri pentru validari
    const [originalName, setOriginalName] = useState("");
    const [nameError, setErrorName] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false, 
        message: "",
        severity: "error"
    })

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get(`/type-materials/${id}/`);
                setFormData(response.data);
                setOriginalName(response.data.name); //salvam numele original
            } catch (error) {
                console.error("Error fetching type material:", error);
                setSnackbar({
                    open: true,
                    message: "Eroare la incarcarea datelor",
                    severity: "error"
                });
            }
        };

        fetchData();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));

        //resetam eroarea cand utilizatorul modifica campul name
        if(name === "name") {
            setErrorName("");
        }
    };

    //functie pentru verificare existentei denumirii (excluzand inregistrarea curenta)
    const checkNameExists = async(name) => {
        if(!name.trim() || name === originalName) {
            return false; //daca numele nu s-a schimbat, nu verificam
        }

        try {
            const response = await axiosInstance.get("/type-materials/check-name/", {
                params: {
                    title: name.trim(),
                    exclude_id: id //trimite ID ul pentru a exclude inregistrarea curenta din verificare
                }
            });
            return response.data.exists;
        } catch (error) {
            console.error("Error checking name: ", error);
            return false;
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({...snackbar, open: false});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        //prevenim submitul multiplu
        if(isSubmitting) return;
        setIsSubmitting(true);

        try {
           //verificam daca numele exista deja (doar daca s-a modificat)
           const nameExists = await checkNameExists(formData.name);

           if(nameExists) {
            setErrorName("A material type with this quality already exists in the system!");
            setSnackbar({
                open: true,
                message: "A material quality with this name already exists. Please enter a unique name!",
                severity: "error"
            });
            setIsSubmitting(false);
            return;
           }

           //daca numele nu exista sau nu s-a modificat, actualizam datele
           const response = await axiosInstance.put(`/type-materials/${id}/`, formData);
           console.log("Updated successfully: ", response.data);

           setSnackbar({
            open: true, 
            message: "The material type was updated successfully!", 
            severity: "success"
           })

           //navigam inapoi dupa un scurt delay
           setTimeout(() => {
            navigate(-1);
           }, 1500);
        } catch (error) {
            console.error("Error updating type material:", error.response?.data || error.message);

            //verifivcam daca eroarea vine de la backend
            if(error.response?.data?.name) {
                setErrorName("A material type with this quality already exists in the system!");
                setSnackbar({
                    open: true, 
                    message: "A material quality with this name already exists. Please enter a unique name!", 
                    severity: "error"
                })
            } else {
                setSnackbar({
                    open: true, 
                    message: "An error occurred while updating the data.",
                    severity: "error"
                });
            }
            setIsSubmitting(false);
        }
    };

    return (
        <div className="materials-page">
        <div className="add-materials-container">
            <div className="materials-header">
                <ArrowBackIcon className="back-arrow" onClick={() => navigate(-1)} />
                    <h2 className="add-materials-title">Edit Type of Materials</h2>
            </div>
        </div>

            <hr className="title-separator"/>
            
        <div className="add-materials-container">
            <form onSubmit={handleSubmit} className="add-materials-form">
                <div className="form-group">
                    <label htmlFor="name" className="label">
                        Quality of material<span className="required-star">*</span>
                    </label>
                    <input 
                        id="name"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="input"
                        required
                    />
                    {nameError && (
                        <div className="error-message" style={{color: "#d32f2f", fontSize: '0.875rem'}}>
                            {nameError}
                        </div>
                    )}
                </div>

                <div className="form-group">
                    <label htmlFor="code" className="label">
                        Standard<span className="required-star">*</span>
                    </label>
                    <input
                        id="code"
                        type="text"
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        className="input"
                        required
                    />
                </div>

                <button 
                type="submit" 
                className="button-save"
                disabled={isSubmitting}
                >
                    {isSubmitting ? "Updating..." : "Update"}
                </button>
            </form>
        </div>

        {/* Snackbar pentru notificări */}
        <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <Alert
            onClose={handleCloseSnackbar}
            severity={snackbar.severity}
            sx={{width: '100%'}}
            >
                {snackbar.message}
            </Alert>
        </Snackbar>
        </div>
    );
}

export default EditTypeMaterials;